import { render, staticRenderFns } from "./NpaComments.vue?vue&type=template&id=4bfa6cbc&scoped=true"
import script from "./NpaComments.vue?vue&type=script&lang=js"
export * from "./NpaComments.vue?vue&type=script&lang=js"
import style0 from "./NpaComments.vue?vue&type=style&index=0&id=4bfa6cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfa6cbc",
  null
  
)

export default component.exports